import { useMemo, useState } from "react"
import { ColumnDef } from "@tanstack/react-table"
import { CallDataSourceDto } from "@dialogics/shared/dto/types.ts"
import { useCallDataSourcesQuery, useDeleteCallDataSourceMutation } from "./service"
import { useProfileQuery } from "../auth/service"
import { EditDataSourceModal } from "./data-sources-edit.tsx"
import { RunIngestionModal } from "./run-ingestion-modal.tsx"
import { RunTranscriptionModal } from "./run-transcription-modal.tsx"
import { ReactTailwindTable, useTable } from "@component/react-tailwind-table"

interface DataSourcesPageProps {
  organizationId?: unknown
}

export function DataSourcesList({ organizationId }: DataSourcesPageProps) {
  const { data: profile } = useProfileQuery()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedDataSource, setSelectedDataSource] = useState<CallDataSourceDto | null>(null)
  const [ingestionDataSource, setIngestionDataSource] = useState<CallDataSourceDto | null>(null)
  const [transcriptionDataSource, setTranscriptionDataSource] = useState<CallDataSourceDto | null>(null)
  const [deleteDataSource] = useDeleteCallDataSourceMutation()
  const { pagination, setPagination } = useTable({ defaultPageSize: 10 })

  const columns = useMemo<ColumnDef<CallDataSourceDto>[]>(
    () => [
      {
        header: "ИД",
        accessorKey: "id",
      },
      {
        header: "Тип",
        accessorKey: "type",
      },
      {
        header: "Активен",
        accessorKey: "is_active",
        cell: info => (info.getValue() ? "Да" : "Нет"),
      },
      {
        header: "Действия",
        cell: ({ row }) => (
          <div className="flex space-x-2">
            <button
              className="btn btn-sm btn-outline"
              onClick={() => {
                setSelectedDataSource(row.original)
                setIsModalOpen(true)
              }}
            >
              Редактировать
            </button>
            <button className="btn btn-sm btn-outline btn-primary" onClick={() => setIngestionDataSource(row.original)}>
              Запустить загрузку
            </button>
            <button className="btn btn-sm btn-outline btn-primary" onClick={() => setTranscriptionDataSource(row.original)}>
              Запустить транскрибацию
            </button>
            <button className="btn btn-sm btn-outline btn-error" onClick={() => deleteDataSource(row.original.id)}>
              Удалить
            </button>
          </div>
        ),
      },
    ],
    [deleteDataSource],
  )

  if (!profile) {
    return <div>Загрузка...</div>
  }

  return (
    <div className="max-w-7xl mx-auto bg-white dark:bg-base-200 p-6 sm:p-8 rounded-lg shadow-sm">
      <div className="flex justify-end mb-4">
        <button
          className="btn btn-primary"
          onClick={() => {
            setSelectedDataSource(null)
            setIsModalOpen(true)
          }}
        >
          Добавить источник данных
        </button>
      </div>
      <ReactTailwindTable
        query={useCallDataSourcesQuery}
        queryParams={{ organization_id: organizationId }}
        columns={columns}
        pagination={pagination}
        setPagination={setPagination}
      />
      {isModalOpen && (
        <EditDataSourceModal
          dataSource={selectedDataSource}
          organizationId={organizationId as number | undefined}
          onClose={() => setIsModalOpen(false)}
          isOpen={isModalOpen}
        />
      )}
      {ingestionDataSource && (
        <RunIngestionModal dataSource={ingestionDataSource} onClose={() => setIngestionDataSource(null)} />
      )}
      {transcriptionDataSource && (
        <RunTranscriptionModal dataSource={transcriptionDataSource} onClose={() => setTranscriptionDataSource(null)} />
      )}
    </div>
  )
}
